import { createSlice } from "@reduxjs/toolkit";

const selectedMenuSlice = createSlice({
  name: "selectedMenu",
  initialState: {
    selectedMenu: "",
  },
  reducers: {
    setMenu: (state, action) => {
      state.selectedMenu = action.payload;
    },
    clearMene: (state) => {
      state.selectedMenu = "";
    },
  },
});

export const { getMenu, setMenu, clearMene } = selectedMenuSlice.actions;

export default selectedMenuSlice.reducer;
